<template>
  <b-button
    class="button d-inline-block rounded-circle project-initials-btn"
    :style="{
      backgroundColor: projectColor || '#6c757d',
      borderColor: projectColor || '#6c757d',
    }"
    variant="secondary"
    size="sm"
    v-b-tooltip.hover="{ variant: 'base', placement: 'top',
    placement:'top',
    boundary:'viewport' }"
    :title="tooltipTitle"
    @click="$emit('click', projectData)"
  >
    {{ getInitials(projectName) }}
  </b-button>
</template>

<script>
import { getInitials } from '@/utils/stringUtils'

export default {
  name: 'ProjectInitialsButton',
  props: {
    projectName: {
      type: String,
      required: true
    },
    projectColor: {
      type: String,
      default: '#6c757d'
    },
    projectData: {
      type: Object,
      required: true
    },
    tooltipTitle: {
      type: String,
      default: 'Hours and payments report'
    }
  },
  methods: {
    getInitials
  }
}
</script>

<style lang="scss" scoped>
.project-initials-btn {
  width: 33px;
  height: 33px;
  min-width: 33px;
  min-height: 33.7px;
  color: #fff;
  font-family: Ubuntu;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &:hover {
    color: #fff;
    text-decoration: none;
  }
}</style>
